export const CREDIT_ASSISTANCE_PATH = "credit-assistance";

export const BCR_SITE_CONFIGURATION = {
	[CREDIT_ASSISTANCE_PATH]: {
		showFeaturedCompany: true,
		preventRenderingCompanyListHeader: true,
	},
};
